import { SelectOption } from '@frontend/components/basic-forms';
import { TransactionEnumClient } from '@frontend/transaction/api';
import { TransactionState, TransactionStateName } from '@frontend/transaction/types';
import { useEffect, useState } from 'react';

export const useTransactionStatesField = () => {
    const [options, setOptions] = useState<SelectOption<TransactionStateName>[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        TransactionEnumClient.fetchTransactionStates().then((states) => {
            setOptions(
                states.map((state) => {
                    const found = TransactionState.ALL.find((t) => t.value === state);
                    if (found) {
                        return {
                            value: found.value,
                            label: found.value,
                            display: found.displayName
                        };
                    }
                    return {
                        value: state as TransactionStateName,
                        label: state.replace(/_/g, ' ')
                    };
                })
            );
            setIsLoading(false);
        });
    }, []);

    return { options, isLoading };
};
